// External packages
import toast from 'react-hot-toast';

interface ToastOptions {
  duration?: number;
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
}

export const useToast = () => {
  const showSuccess = (message: string, options?: ToastOptions) => {
    toast.success(message, {
      duration: options?.duration || 4000,
      position: options?.position || 'top-right',
      style: {
        background: '#10b981',
        color: 'white',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      iconTheme: {
        primary: 'white',
        secondary: '#10b981',
      },
    });
  };

  const showError = (message: string, options?: ToastOptions) => {
    toast.error(message, {
      duration: options?.duration || 5000,
      position: options?.position || 'top-right',
      style: {
        background: '#ef4444',
        color: 'white',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      iconTheme: {
        primary: 'white',
        secondary: '#ef4444',
      },
    });
  };

  const showInfo = (message: string, options?: ToastOptions) => {
    toast(message, {
      duration: options?.duration || 4000,
      position: options?.position || 'top-right',
      style: {
        background: '#3b82f6',
        color: 'white',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      icon: 'ℹ️',
      iconTheme: {
        primary: 'white',
        secondary: '#3b82f6',
      },
    });
  };

  const showWarning = (message: string, options?: ToastOptions) => {
    toast(message, {
      duration: options?.duration || 4000,
      position: options?.position || 'top-right',
      style: {
        background: '#f59e0b',
        color: 'white',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      icon: '⚠️',
      iconTheme: {
        primary: 'white',
        secondary: '#f59e0b',
      },
    });
  };

  return {
    success: showSuccess,
    error: showError,
    info: showInfo,
    warning: showWarning,
  };
};
